import { DispatchThunk } from '../../types/common';
import { Experiment, Variant } from '../../utils/constants';
import { assignAnonymousExperiment, assignRegisteredUserExperiment } from '../../utils/experiments';
import { getExperimentVariant } from '../selectors/config';

export const UPDATE_EXPERIMENTS = 'APP_UPDATE_EXPERIMENTS';

export function updateExperimentVariant(experiment: Experiment, variant: string) {
  return {
    type: UPDATE_EXPERIMENTS,
    payload: {
      [experiment]: variant,
    },
  };
}

export function ensureExperimentVariant(
  experiment: Experiment,
  isAnonymous = true,
): DispatchThunk<Promise<string>> {
  return async (dispatch, getState) => {
    let variant = getExperimentVariant(getState(), experiment);
    if (!variant) {
      variant =
        (await (isAnonymous ? assignAnonymousExperiment : assignRegisteredUserExperiment)(
          experiment,
        )) || Variant.EXCLUDED;
      dispatch(updateExperimentVariant(experiment, variant));
    }
    return variant;
  };
}
